// src/components/common/aia/tours/index.js
import { employeeTours, getEmployeeTour, getAllEmployeeTours } from './employeeTours';
import { managerTours, getManagerTour, getAllManagerTours } from './managerTours';
import { adminTours, getAdminTour, getAllAdminTours } from './adminTours';

export { employeeTours, getEmployeeTour, getAllEmployeeTours };
export { managerTours, getManagerTour, getAllManagerTours };
export { adminTours, getAdminTour, getAllAdminTours };

// Get tours by role
export const getToursByRole = (role) => {
    switch (role) {
        case 'employee':
            return employeeTours;
        case 'manager':
            return managerTours;
        case 'admin':
            return adminTours;
        default:
            return [];
    }
};

// Get auto-start tour for role
export const getAutoStartTour = (role) => {
    const tours = getToursByRole(role);
    return tours.find(tour => tour.autoStart) || null;
};

// Get tour by ID and role
export const getTourById = (tourId, role) => {
    const tours = getToursByRole(role);
    return tours.find(tour => tour.id === tourId) || null;
};
